
export function isPointInConvexPolygon(point:{lat:number, lng:number}, polygon:({lat:number, lng: number})[]) {
    const { lat, lng } = point;
    const numVertices = polygon.length;
    let prevSign = null;

    for (let i = 0; i < numVertices; i++) {
        const a = polygon[i];
        const b = polygon[(i + 1) % numVertices];

        // Векторное произведение для определения направления
        const cross = (b.lng - a.lng) * (lat - a.lat) - (b.lat - a.lat) * (lng - a.lng);

        // Сохраняем знак
        const sign = Math.sign(cross);
        if (sign === 0) continue; // точка на ребре

        if (prevSign === null) {
            prevSign = sign;
        } else if (prevSign !== sign) {
            return false; // разные знаки — точка вне полигона
        }
    }

    return true;
}